import { render } from "./LogsFilters.vue?vue&type=template&id=28b74674"
import script from "./LogsFilters.vue?vue&type=script&lang=js"
export * from "./LogsFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__